// extracted by mini-css-extract-plugin
module.exports = {"rootStyle":"CG-YQ","disabled":"_3mO-k","footerContainer":"_24jTh","footerBtn":"_2I6Ib","title":"_37hVc"};